// Botón "Volver arriba" con aro de progreso de scroll.
// Antes vivía como <script> inline en theme.liquid. Extraído en mayo 2026.

(function () {
  var container = document.getElementById('back-to-top');
  if (!container) return;
  var btn = container.querySelector('button');
  var ringFG = container.querySelector('.ring__fg');
  var showAfter = 300; // px para mostrar el botón

  // Cálculo circunferencia del aro
  var r = 23;
  var C = 2 * Math.PI * r;
  ringFG.style.strokeDasharray = C + ' ' + C;

  function getScrollTop() {
    return window.pageYOffset || document.documentElement.scrollTop || 0;
  }
  function getDocHeight() {
    var body = document.body,
      html = document.documentElement;
    return Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    );
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    window.requestAnimationFrame(function () {
      var y = getScrollTop();
      var h = getDocHeight() - window.innerHeight;
      var progress = h > 0 ? Math.min(1, Math.max(0, y / h)) : 0;

      // Mostrar/ocultar
      if (y > showAfter) {
        container.hidden = false;
        container.setAttribute('aria-hidden', 'false');
      } else {
        container.hidden = true;
        container.setAttribute('aria-hidden', 'true');
      }

      // Actualizar aro (offset inverso para que se "llene" al bajar)
      var offset = C * (1 - progress);
      ringFG.style.strokeDashoffset = offset;

      ticking = false;
    });
    ticking = true;
  }

  function scrollTop() {
    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    try {
      window.scrollTo({ top: 0, behavior: prefersReduced ? 'auto' : 'smooth' });
    } catch (e) {
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }
  }

  btn.addEventListener('click', scrollTop);
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll(); // inicial
})();
